import { ComponentProps } from 'react';

import cx from 'classnames';

import styles from './ButtonOAuth.module.scss';
import { Icon, TIconImages } from '../icons/Icon';
import { TextBlock } from '../common';

type TButtonOAuthProps = {
  icon: TIconImages;
  text?: string;
  url: string;
} & ComponentProps<'button'>;

export const ButtonOAuth = ({
  className,
  icon,
  text,
  url,
  ...rest
}: TButtonOAuthProps) => {
  const handleClick = () => {
    window.location.href = url;
  };

  return (
    <button
      className={cx(styles.buttonOAuth, className)}
      onClick={handleClick}
      type="button"
      {...rest}
    >
      <Icon img={icon} size="l" type="colored" />

      <TextBlock className={styles.text} color="contrast">
        {text}
      </TextBlock>
    </button>
  );
};
